
function initPriceRangeSlider(options = {}) {
  const {
    container = document,
    minGap = 100,
    onChange = function () {}
  } = options;
  const minRange = container.querySelector('.range-min');
  const maxRange = container.querySelector('.range-max');
  const track = container.querySelector('.range-track');
  const minText = container.querySelector('.min-val');
  const maxText = container.querySelector('.max-val');

  if (!minRange || !maxRange || !track) return;

  const maxValue = parseInt(minRange.max, 10);
  const format = v => '$' + Number(v).toLocaleString();

  function updateTrack(min, max) {
    const left = (min / maxValue) * 100;
    const right = 100 - (max / maxValue) * 100;
    track.style.setProperty('--left', left + '%');
    track.style.setProperty('--right', right + '%');
  }

    function handleChange(e) {
      let min = parseInt(minRange.value, 10);
      let max = parseInt(maxRange.value, 10);
      if (max - min < minGap) {
        if (e && e.target === minRange) {
          min = max - minGap;
          minRange.value = min;
        } else {
          max = min + minGap;
          maxRange.value = max;
        }
      }
      if (minText) minText.textContent = format(min);
      if (maxText) maxText.textContent = format(max);
      updateTrack(min, max);
      onChange(min, max);
    }

  minRange.addEventListener('input', handleChange);
  maxRange.addEventListener('input', handleChange);

  handleChange();
}

function setupCollectionPriceFilter(container = document) {
  initPriceRangeSlider({
    container,
    minGap: 100,
    onChange(min, max) {
      const minInput = container.querySelector('[name="filter.v.price.gte"]');
      const maxInput = container.querySelector('[name="filter.v.price.lte"]');

      if (minInput) minInput.value = min;
      if (maxInput) maxInput.value = max;
    }
  });
}

function getPriceFilterFromURL() {
  const paramss = new URLSearchParams(window.location.search);

  const min = paramss.get('filter.v.price.gte');
  const max = paramss.get('filter.v.price.lte');

  if (min !== null && max !== null) {
    return {
      min: parseInt(min, 10),
      max: parseInt(max, 10)
    };
  }

  return null;
}

function formatMoney(amount) {
  return new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: window.storeCurrency
  }).format(amount);
}


function updateUI() {
  const price = getPriceFilterFromURL();
  if (!price) return;

  const minRange = document.querySelector('.range-min');
  const maxRange = document.querySelector('.range-max');
  const track = document.querySelector('.range-track');
  const minText = document.querySelector('.range-values .min-val');
  const maxText = document.querySelector('.range-values .max-val');
  if (minText) minText.textContent = '---';
  if (maxText) maxText.textContent = '---';
  if (!minRange || !maxRange || !track) return;

  const minLimit = parseFloat(minRange.min) || 0;
  const maxLimit = parseFloat(minRange.max) || 100;

  let min = parseFloat(price.min);
  let max = parseFloat(price.max);

  if (isNaN(min)) min = minLimit;
  if (isNaN(max)) max = maxLimit;

  min = Math.max(minLimit, Math.min(min, maxLimit));
  max = Math.max(minLimit, Math.min(max, maxLimit));

  if (min > max) min = max;

  minRange.value = min;
  maxRange.value = max;

  const left = ((min - minLimit) / (maxLimit - minLimit)) * 100;
  const right = 100 - ((max - minLimit) / (maxLimit - minLimit)) * 100;

  track.style.setProperty('--left', left + '%');
  track.style.setProperty('--right', right + '%');

  if (minText) minText.textContent = formatMoney(min);
  if (maxText) maxText.textContent = formatMoney(max);
}



document.addEventListener('DOMContentLoaded', () => {
  if (window.location.href.includes('collections')){
   setupCollectionPriceFilter();
  };

});
  

function openadd(){
  document
    .querySelectorAll('.mobile-facets details')
    .forEach(d => d.setAttribute('open', ''));

}

document.addEventListener('DOMContentLoaded', () => {
 openadd();
});

function allactiveat(){
$('.active-facets facet-remove .filteractivates').each(function () {
    const datamm = $(this).attr('data-match');
    // $('.collecton-row .collectioncontain .coll-main[data-match="' + datamm + '"]').addClass('active');
});
}

allactiveat();

function loaderact(){
  $('div#ProductGridContainer .loaderrr').addClass('active');
  // $('.collecton-row .collectioncontain .coll-main').removeClass('active');
}

function loaderrmove(){
  $('div#ProductGridContainer .loaderrr').removeClass('active');
  allactiveat();
}

function hoverShapeFromUrl(scope = document) {
    const params = new URLSearchParams(window.location.search);
    const shape = params.get('filter.v.option.shape');
    if (!shape) return;
    const $buttons = $(scope).find(
        `div#ProductGridContainer .card__information .option-btn.shape-btn`
    );
    if (!$buttons.length) return;
    $buttons.each(function () {
        const $button = $(this);
        if ($button.attr('data-option-value') === shape) {
            $button
                .closest('.option-values')
                .find('.shape-btn')
                .removeClass('active');
            $button.addClass('active');
            $button.trigger('mouseenter');
            $button.trigger('mouseover');
        }
    });
}

let productCounter=0;
let metalPattern=[];
let metalPatternIndex=0;
function generateMetalPattern(total=500){
const pattern=[];
let position=0;
while(position<total){
for(let i=0;i<3 && position<total;i++){
pattern.push('yellow');
position++;
}

for(let i=0;i<3 && position<total;i++){
pattern.push('white');
position++;
}
}

let nextRosePosition=Math.floor(Math.random()*3)+12;
while(nextRosePosition<total){
pattern[nextRosePosition]='rose';
nextRosePosition+=Math.floor(Math.random()*3)+12;
}
return pattern;
}

metalPattern=generateMetalPattern();
function selectDifferentVariant(scope=document){
$(scope).find('li[data-created]').each(function(){
const $product=$(this);
if($product.data('variant-selected'))return;
const $buttons=$product.find('.option-row.option-metal .option-values button.option-btn.metal-btn');
if(!$buttons.length)return;
const metalType=metalPattern[metalPatternIndex]||'yellow';
const $matchingButtons=$buttons.filter(function(){
const value=($(this).attr('data-option-value')||'').toLowerCase();
if(!value.includes('14k'))return false;
if(metalType==='yellow')return value.includes('yellow gold');
if(metalType==='white')return value.includes('white gold');
if(metalType==='rose')return value.includes('rose gold');
return false;
});

if(!$matchingButtons.length)return;
const metalButtonIndex=Math.floor(productCounter/13)%$matchingButtons.length;
const $selected=$matchingButtons.eq(metalButtonIndex);
$buttons.removeClass('active');
$selected.addClass('active');
setTimeout(function(){
$selected.trigger('mouseenter');
},0);
$product.data('variant-selected',true);
productCounter++;
metalPatternIndex++;
});
hoverShapeFromUrl(scope);
}

// let productCounter=0;
// let metalPattern=[];
// let metalPatternIndex=0;

// function generateMetalPattern(total=500){
// const pattern=[];
// let position=0;
// while(position<total){
// for(let i=0;i<3 && position<total;i++){
// pattern.push('yellow');
// position++;
// }
// for(let i=0;i<3 && position<total;i++){
// pattern.push('white');
// position++;
// }
// }
// let roseCount=Math.max(1,Math.floor(total*0.01));
// for(let i=0;i<roseCount;i++){
// let rosePosition=Math.floor(Math.random()*total);
// if(pattern[rosePosition]!=='rose'){
// pattern[rosePosition]='rose';
// }
// }
// return pattern;

// }



// metalPattern=generateMetalPattern();
// function selectDifferentVariant(scope=document){
// $(scope).find('li[data-created]').each(function(){
// const $product=$(this);
// if($product.data('variant-selected'))return;
// const $buttons=$product.find('.option-row.option-metal .option-values button.option-btn.metal-btn');
// if(!$buttons.length)return;
// const metalType=metalPattern[metalPatternIndex]||'yellow';
// const $matchingButtons=$buttons.filter(function(){
// const value=($(this).attr('data-option-value')||'').toLowerCase();
// if(metalType==='yellow')return value.includes('yellow gold');
// if(metalType==='white')return value.includes('white gold');
// if(metalType==='rose')return value.includes('rose gold');
// return false;
// });

// if(!$matchingButtons.length)return;
// const metalButtonIndex=Math.floor(productCounter/13)%$matchingButtons.length;
// const $selected=$matchingButtons.eq(metalButtonIndex);
// $buttons.removeClass('active');
// $selected.addClass('active');
// setTimeout(function(){
// $selected.trigger('mouseenter');
// },0);
// $product.data('variant-selected',true);
// productCounter++;
// metalPatternIndex++;
// });
// hoverShapeFromUrl(scope);
// }



function initOptionScroll(context = document) {
  $(context).find('.option-row').each(function () {
    const $row = $(this);
    const $values = $row.find('.option-values');
    const $buttons = $values.find('.option-btn');
    const $prev = $row.find('.prev-btn');
    const $next = $row.find('.next-btn');
    if ($buttons.length <= 5) {
      $prev.addClass('hideee');
      $next.addClass('hideee');
      return;
    }
    $prev.show();
    $next.show();
    const scrollAmount = $buttons.outerWidth(true);
    function updateButtons() {
      const scrollLeft = $values.scrollLeft();
      const maxScroll = $values[0].scrollWidth - $values.outerWidth();
      if (scrollLeft > 0) {
        $prev.addClass('active');
      } else {
        $prev.removeClass('active');
      }
      if (scrollLeft >= maxScroll - 1) {
        $next.addClass('disabled');
      } else {
        $next.removeClass('disabled');
      }
    }
    $next.off('click').on('click', function () {
      if (!$(this).hasClass('disabled')) {
        $values.animate(
          { scrollLeft: $values.scrollLeft() + scrollAmount },
          200,
          updateButtons
        );
      }
    });

    $prev.off('click').on('click', function () {
      $values.animate(
        { scrollLeft: $values.scrollLeft() - scrollAmount },
        200,
        updateButtons
      );
    });
    $values.off('scroll').on('scroll', updateButtons);
    updateButtons();
  });
}


function renderVariantOptions(context = document) {
  $(context).find('.optionscontainer').each(function () {
    const $container = $(this);

    if ($container.data('rendered')) return;
    $container.data('rendered', true);

    const variants = JSON.parse(
      $container.attr('data-variants') || '[]'
    );

    let metaImages = {};
    let metaSecondImages = {};

    try {
      metaImages = JSON.parse(
        $container.attr('data-metafield-images') || '{}'
      );
    } catch (e) {}

    try {
      metaSecondImages = JSON.parse(
        $container.attr('data-metafield-second-images') || '{}'
      );
    } catch (e) {}

    window.nmn = metaImages;

    if (!variants.length) return;

    const OPTION_KEYWORDS = {
      Metal: ['gold', 'platinum', 'metal', 'silver', 'k'],
      Shape: [
        'round',
        'Marquise',
        'oval',
        'pear',
        'emerald',
        'cushion',
        'princess',
        'heart',
        'Radiant'
      ],
      'Total Carat Weight': ['carat', 'ct', 'weight']
    };

    function detectOptionType(values = [], index) {
      return false;

      const sample = values.join(' ').toLowerCase();

      if (
        sample.includes('gold') ||
        sample.includes('platinum') ||
        sample.includes('silver') ||
        /\d+k/.test(sample)
      ) {
        return 'Metal';
      }

      if (
        sample.includes('round') ||
        sample.includes('oval') ||
        sample.includes('pear') ||
        sample.includes('emerald') ||
        sample.includes('cushion') ||
        sample.includes('princess') ||
        sample.includes('radiant') ||
        sample.includes('marquise')
      ) {
        return 'Shape';
      }

      if (
        sample.includes('carat') ||
        sample.includes('ct') ||
        /^\d+(\.\d+)?/.test(sample)
      ) {
        return 'Carat';
      }

      if (index === 1) return 'Metal';
      if (index === 2) return 'Shape';
      if (index === 3) return 'Carat';

      return 'Option';
    }

    function getOptionValues(index) {
      return [
        ...new Set(
          variants
            .map(v => v['option' + index])
            .filter(v => v && v !== 'Default')
        )
      ];
    }

    const optionConfig = [];

    [1, 2, 3].forEach(index => {
      const values = getOptionValues(index);

      if (!values.length) return;

      const type = detectOptionType(values);

      optionConfig.push({
        index,
        name: type,
        parentClass:
          type === 'Metal'
            ? 'option-metal'
            : type === 'Shape'
            ? 'option-shape'
            : 'option-carat'
      });
    });

    optionConfig.forEach(opt => {
      const values = getOptionValues(opt.index);

      if (!values.length) return;

      let buttonsHTML = '';

      values.forEach(value => {
        if (opt.parentClass === 'option-shape') {
          buttonsHTML += `
            <button
              class="option-btn shape-btn"
              data-option-index="${opt.index}"
              data-option-value="${value}">
            </button>
          `;
        } else {
          const displayValue =
            opt.name === 'Metal'
              ? value.match(/\d+K/i)?.[0] || value
              : value;

          buttonsHTML += `
            <button
              class="option-btn metal-btn"
              data-option-index="${opt.index}"
              data-option-value="${value}">
              <span class="bgoption">
                <span class="hoverelement">${displayValue}</span>
              </span>
            </button>
          `;
        }
      });
    });

    let selectedOptions = {};

 $container.off('mouseenter.variant').on('mouseenter.variant','.option-btn',function(){

const $btn=$(this);
const optionIndex=$btn.data('option-index');
const optionValue=$btn.data('option-value');

selectedOptions['option'+optionIndex]=optionValue;

$btn.addClass('active').siblings('.option-btn').removeClass('active');

let matchedVariant=null;

$.each(variants,function(i,variant){
let isMatch=true;

$.each(selectedOptions,function(key,val){
if(variant[key]!=val){
isMatch=false;
return false;
}
});

if(isMatch){
matchedVariant=variant;
return false;
}
});

if(!matchedVariant)return;

const $card=$container.closest('li.grid__item');
let firstImageSrc='';

if(matchedVariant.featured_image&&matchedVariant.featured_image.src){
firstImageSrc=matchedVariant.featured_image.src;
}else if(metaImages&&metaImages[matchedVariant.id]){
firstImageSrc=metaImages[matchedVariant.id];
}

let secondImageSrc='';

if(metaSecondImages&&metaSecondImages[matchedVariant.id]){
secondImageSrc=metaSecondImages[matchedVariant.id];
}

if(!secondImageSrc){
secondImageSrc=firstImageSrc;
}

console.log('Variant:',matchedVariant.id);
console.log('First image:',firstImageSrc);
console.log('Second image:',secondImageSrc);

const $images=$card.find('.card .media.media--hover-effect img');

if($images.eq(0).length&&firstImageSrc){
$images.eq(0).attr({
src:firstImageSrc,
srcset:firstImageSrc
});
}

if($images.eq(1).length&&secondImageSrc){
$images.eq(1).attr({
src:secondImageSrc,
srcset:secondImageSrc
});
}

const mainPrice=matchedVariant.price/100;

const comparePrice=matchedVariant.compare_at_price?matchedVariant.compare_at_price/100:null;

const formatPrice=function(price){
return Number(price).toLocaleString('en-US',{
minimumFractionDigits:0,
maximumFractionDigits:2
});
};

$card.find('.price__regular .price-item--regular, span.price-item.price-item--regular.dddddddd').html('$'+formatPrice(mainPrice));

if(comparePrice&&comparePrice>mainPrice){

$card.find('.card-information span.cros_price_compare').html('$'+formatPrice(comparePrice));

const priceDifference=comparePrice-mainPrice;

$card.find('.card-information span.price_difference').html('Save $ '+formatPrice(priceDifference));

}else{

$card.find('.card-information span.cros_price_compare').html('');

$card.find('.card-information span.price_difference').html('');
} 

const $link=$card.find('.card__information h3.card__heading.h5 a');

if($link.length){

const currentHref=$link.attr('href')||'';
const baseUrl=currentHref.split('?')[0];

$link.attr('href',baseUrl+'?variant='+matchedVariant.id);

}

});


  });

  /*
   * ==========================================
   * EXISTING INITIALIZATIONS
   * ==========================================
   */

  initOptionScroll(context);

  firstselected();

  openadd();

  setupCollectionPriceFilter(context);

  addIndexToProductGrid();

  setTimeout(function () {
    updateUI();
  }, 500);

  setTimeout(function () {
    selectDifferentVariant();
  }, 200);
}


// function renderVariantOptions(context = document) {
//   $(context).find('.optionscontainer').each(function () {
//     const $container = $(this);
//     if ($container.data('rendered')) return;
//     $container.data('rendered', true);

//     const variants = JSON.parse($container.attr('data-variants') || '[]');

//     let metaImages = {};
//     try {
//       metaImages = JSON.parse($container.attr('data-metafield-images') || '{}');
//     } catch (e) {}
//     window.nmn = metaImages;

//     if (!variants.length) return;

//     const OPTION_KEYWORDS = {
//       Metal: ['gold', 'platinum', 'metal', 'silver', 'k'],
//       Shape: ['round','Marquise', 'oval', 'pear', 'emerald', 'cushion', 'princess', 'heart', 'Radiant'],
//       'Total Carat Weight': ['carat', 'ct', 'weight']
//     };

//     function detectOptionType(values = [], index) {
//       return false;
//       const sample = values.join(' ').toLowerCase();

//       if (
//         sample.includes('gold') ||
//         sample.includes('platinum') ||
//         sample.includes('silver') ||
//         /\d+k/.test(sample)
//       ) {
//         return 'Metal';
//       }

//       if (
//         sample.includes('round') ||
//         sample.includes('oval') ||
//         sample.includes('pear') ||
//         sample.includes('emerald') ||
//         sample.includes('cushion') ||
//         sample.includes('princess') || 
//         sample.includes('radiant') || 
//         sample.includes('marquise') 
//       ) {
//         return 'Shape';
//       }

//       if (
//         sample.includes('carat') ||
//         sample.includes('ct') ||
//         /^\d+(\.\d+)?/.test(sample)
//       ) {
//         return 'Carat';
//       }

//       if (index === 1) return 'Metal';
//       if (index === 2) return 'Shape';
//       if (index === 3) return 'Carat';
 
//       return 'Option';
//     }

//     function getOptionValues(index) {
//       return [
//         ...new Set(
//           variants
//             .map(v => v['option' + index])
//             .filter(v => v && v !== 'Default')
//         )
//       ];
//     }

//     const optionConfig = [];

//     [1, 2, 3].forEach(index => {
//       const values = getOptionValues(index);
//       if (!values.length) return;

//       const type = detectOptionType(values);

//       optionConfig.push({
//         index,
//         name: type,
//         parentClass:
//           type === 'Metal'
//             ? 'option-metal'
//             : type === 'Shape'
//             ? 'option-shape'
//             : 'option-carat'
//       });
//     });

//     optionConfig.forEach(opt => {
//       const values = getOptionValues(opt.index);
//       if (!values.length) return;

//       let buttonsHTML = '';

//       values.forEach(value => {
//         if (opt.parentClass === 'option-shape') {
//           buttonsHTML += `
//             <button class="option-btn shape-btn"
//               data-option-index="${opt.index}"
//               data-option-value="${value}">
//             </button>
//           `;
//         } else {
//           const displayValue =
//             opt.name === 'Metal'
//               ? value.match(/\d+K/i)?.[0] || value
//               : value;

//           buttonsHTML += `
//             <button class="option-btn metal-btn"
//               data-option-index="${opt.index}"
//               data-option-value="${value}">
//               <span class="bgoption">
//                 <span class="hoverelement">${displayValue}</span>
//               </span>
//             </button>
//           `;
//         }
//       });

  
//     });

//     let selectedOptions = {};

// $container
//   .off('mouseenter.variant')
//   .on('mouseenter.variant', '.option-btn', function () {

//     var $btn = $(this);
//     var optionIndex = $btn.data('option-index');
//     var optionValue = $btn.data('option-value');

//     selectedOptions['option' + optionIndex] = optionValue;

//     $btn.addClass('active')
//       .siblings('.option-btn')
//       .removeClass('active');

//     var matchedVariant = null;

//     $.each(variants, function (i, variant) {
//       var isMatch = true;

//       $.each(selectedOptions, function (key, val) {
//         if (variant[key] != val) {
//           isMatch = false;
//           return false;
//         }
//       });

//       if (isMatch) {
//         matchedVariant = variant;
//         return false;
//       }
//     });

//     if (!matchedVariant) return;

//     var $card = $container.closest('li.grid__item');

//     // Update variant image
//     var imageSrc = '';

//     if (matchedVariant.featured_image && matchedVariant.featured_image.src) {
//       imageSrc = matchedVariant.featured_image.src;
//     } else if (metaImages && metaImages[matchedVariant.id]) {
//       imageSrc = metaImages[matchedVariant.id];
//     }

//     console.log(imageSrc, 'imageSrc');

//     if (imageSrc) {
//       $card.find('.card .media img').attr({
//         src: imageSrc,
//         srcset: imageSrc
//       });
//     }

//     // Get variant prices
//     var mainPrice = matchedVariant.price / 100;

//     var comparePrice = matchedVariant.compare_at_price
//       ? matchedVariant.compare_at_price / 100
//       : null;

//     // Show main price
//     $card.find(
//       '.price__regular .price-item--regular, span.price-item.price-item--regular.dddddddd'
//     ).html('$' + mainPrice);

//     // Show compare price and calculate savings
//     if (comparePrice && comparePrice > mainPrice) {

//       // Compare price
//       $card.find('.card-information span.cros_price_compare')
//         .html('$' + comparePrice);

//       // Difference / savings
//       var priceDifference = comparePrice - mainPrice;

//       $card.find('.card-information span.price_difference')
//         .html('Save $ ' + priceDifference);

//     } else {

//       // No compare price
//       $card.find('.card-information span.cros_price_compare')
//         .html('');

//       // No savings
//       $card.find('.card-information span.price_difference')
//         .html('');
//     }

//     // Update variant link
//     var $link = $card.find('.card__information h3.card__heading.h5 a');

//     if ($link.length) {
//       var baseUrl = $link.attr('href').split('?')[0];

//       $link.attr(
//         'href',
//         baseUrl + '?variant=' + matchedVariant.id
//       );
//     }

//   });

//    });

//   initOptionScroll(context);
//   firstselected();
//   openadd();
//   setupCollectionPriceFilter(context);
//   addIndexToProductGrid();
//   setTimeout(function() { 
//   updateUI ();
//   }, 500);

//   setTimeout(function() { 
//   selectDifferentVariant();
//   }, 200);
// }
 

$(document).ready(function () {
  renderVariantOptions();
});


function insertPromoCard() {
  const productGrid = document.querySelector('#product-grid');
  if (!productGrid) return;

  const existingPromo = productGrid.querySelector('.imagemodule');
  if (existingPromo) existingPromo.remove();

  const items = Array.from(productGrid.querySelectorAll('li'))
    .filter(li => !li.classList.contains('imagemodule'));

  // Detect mobile
  const isMobile = window.innerWidth <= 749;

  // Set position
  const insertIndex = isMobile ? 9 : 8; // 9th position (index 8)

  if (items.length < insertIndex + 1) return;

  const promoLi = document.createElement('li');
  promoLi.className = 'grid__item imagemodule mmede';
  promoLi.innerHTML = `
    <div class="collection-promo-card">
      <img
        src="https://cdn.shopify.com/s/files/1/0766/9986/1205/files/Group_303_1.png?v=1773908264"
        alt="Ready to Ship Rings"
        loading="lazy"
      >
    </div>
  `;

  const referenceNode = items[insertIndex];

  if (referenceNode && referenceNode.parentNode === productGrid) {
    productGrid.insertBefore(promoLi, referenceNode);
  } else {
    productGrid.appendChild(promoLi);
  }
}

function addIndexToProductGrid() {
  const items = document.querySelectorAll('#product-grid li.imagemodule');
  const itemsss = document.querySelectorAll('#product-grid li.imagemodulefirst');

  itemsss.forEach((el, index) => {
    if (index !== 0) {
      el.style.display = 'none';
    }
  });

  items.forEach((el, index) => {
    if (index !== 0) {
      el.style.display = 'none';
    }
  });
}




let infiniteObserver = null;
let infiniteLoading = false;
let infiniteFinished = false;
let loadedPages = new Set();
 
function initInfiniteScroll() {

  if ($('body[page-type="diamonds"]').length) return;
  if (!window.location.pathname.includes('/collections/')) return;

  const productGrid = document.querySelector('#product-grid');
  if (!productGrid) return;

  // Kill old observer
  if (infiniteObserver) {
    infiniteObserver.disconnect();
    infiniteObserver = null;
  }

  infiniteLoading = false;
  infiniteFinished = false;
  loadedPages = new Set();
  let currentPage = 1;

  loadedPages.add(1);


  function observeTrigger() {

    if (infiniteFinished) return;

    if (infiniteObserver) {
      infiniteObserver.disconnect();
      infiniteObserver = null;
    }

    const items = productGrid.querySelectorAll(
      'li[data-product-id]'
    );

    if (!items.length) return;

    const triggerItem =
      items[Math.max(0, items.length - 2)];

    infiniteObserver =
      new IntersectionObserver(
        function(entries) {

          if (!entries.length) return;

          if (!entries[0].isIntersecting) return;

          if (infiniteLoading) return;
          if (infiniteFinished) return;

          loadNextPage();

        },
        {
          root: null,

          // Works for desktop + iOS
          rootMargin: '1000px 0px 1000px 0px',

          threshold: 0
        }
      );

    infiniteObserver.observe(triggerItem);
  }


  async function loadNextPage() {

    if (infiniteLoading) return;
    if (infiniteFinished) return;

    const nextPage = currentPage + 1;

    if (loadedPages.has(nextPage)) {
      return;
    }

    infiniteLoading = true;

    const nextUrl =
      new URL(window.location.href);

    nextUrl.searchParams.set(
      'page',
      nextPage
    );

    console.log(
      'Infinite scroll loading:',
      nextUrl.toString()
    );

    try {

      const response =
        await fetch(
          nextUrl.toString(),
          {
            method: 'GET',
            headers: {
              'X-Requested-With': 'XMLHttpRequest'
            },
            cache: 'default'
          }
        );

      if (!response.ok) {
        throw new Error(
          `HTTP ${response.status}`
        );
      }

      const text =
        await response.text();

      const doc =
        new DOMParser()
          .parseFromString(
            text,
            'text/html'
          );

      const newGrid =
        doc.querySelector(
          '#product-grid'
        );

      if (!newGrid) {
        finishInfinite();
        return;
      }

      /*
       * ONLY product items.
       */
      const newItems =
        Array.from(
          newGrid.querySelectorAll(
            'li[data-product-id]'
          )
        );

      console.log(
        `Page ${nextPage} returned ${newItems.length} products`
      );


      if (!newItems.length) {
        finishInfinite();
        return;
      }


      /*
       * Existing product IDs
       */
      const existingIds =
        new Set();

      productGrid
        .querySelectorAll(
          'li[data-product-id]'
        )
        .forEach(function(item) {

          const id =
            item.dataset.productId;

          if (id) {
            existingIds.add(
              String(id)
            );
          }

        });


      let addedCount = 0;


      /*
       * Append new products.
       */
      newItems.forEach(function(item) {

        const id =
          item.dataset.productId;

        if (!id) return;

        const normalizedId =
          String(id);

        if (
          !existingIds.has(
            normalizedId
          )
        ) {

          productGrid.appendChild(item);

          existingIds.add(
            normalizedId
          );

          addedCount++;
        }

      });


      /*
       * Page successfully loaded.
       */
      currentPage = nextPage;

      loadedPages.add(
        nextPage
      );


      console.log(
        `Page ${nextPage}: added ${addedCount} products`
      );

      insertPromoCard();
      addIndexToProductGrid();

      setTimeout(function() {

        renderVariantOptions();

      }, 300);

      requestAnimationFrame(function() {

        requestAnimationFrame(function() {

          infiniteLoading = false;

          observeTrigger();

        });

      });

    } catch (error) {

      console.error(
        'Infinite scroll error:',
        error
      );

      loadedPages.delete(
        nextPage
      );

      infiniteLoading = false;

      /*
       * Re-observe so user can retry.
       */
      observeTrigger();
    }
  }


  function finishInfinite() {

    if (infiniteFinished) return;

    infiniteFinished = true;
    infiniteLoading = false;

    if (infiniteObserver) {

      infiniteObserver.disconnect();

      infiniteObserver = null;
    }

    console.log(
      'Infinite scroll finished at page:',
      currentPage
    );
  }


  /*
   * Start observer.
   */
  observeTrigger();
}



let isCollectionLoading = false;

async function fetchAnotherCollection(handle) {

  if (isCollectionLoading) return;
  isCollectionLoading = true;

  $('div#ProductGridContainer .loaderrr').addClass('active');
  const queryString = window.location.search;
  let newUrl = `/collections/${handle}${queryString}`;

  try {
    const response = await fetch(newUrl);
    const html = await response.text();

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const newProducts = doc.querySelector('#items_selected_prdct');
    const collname = doc.querySelector('.collectiontitle .collectiontititit h1');
    const totalItems = doc.querySelector('#items_selected_prdct span#ProductCount');
    const breadcr = doc.querySelector('nav.breadcrumbs.pagescontainer');

    const currentGrid = document.querySelector('#items_selected_prdct');
    const collnames = document.querySelector('.collectiontitle .collectiontititit h1');
    const breadcrumbs = document.querySelector('nav.breadcrumbs.pagescontainer');

    if (newProducts && currentGrid) {
      currentGrid.innerHTML = newProducts.innerHTML;
    }

    if (breadcr && breadcrumbs) {
      breadcrumbs.innerHTML = breadcr.innerHTML;
    }

    if (collname && collnames) {
      collnames.innerHTML = collname.innerHTML;
    }

    if (totalItems) {
      const totalIsss = document.querySelector('span.total-items.colll');
      if (totalIsss) {
        totalIsss.innerHTML = totalItems.innerHTML + ' Results';
      }
    }

    window.history.pushState({}, '', newUrl);
    renderVariantOptions();
    setTimeout(() => {
    initInfiniteScroll();
    }, 100);

  } catch (err) {
    console.error('Collection fetch error:', err);
  }
 
  isCollectionLoading = false;
}




document.addEventListener('DOMContentLoaded', function () {
  initInfiniteScroll();
});


// RESET WRAPPER CLICK
document.addEventListener('click', async function (e) {
  const resetBtn = e.target.closest('.reset-wrapper');
  if (!resetBtn) return;
  const collectionContain = document.querySelector('.collectioncontain');
  if (!collectionContain) return;
  const parenttt = collectionContain.getAttribute('parent-collection');
  const activeItems = document.querySelectorAll('.coll-main.active');
  if (activeItems.length > 0) {
    const img = resetBtn.querySelector('img');
    if (img) {
      img.style.transition = 'transform 1s ease';
      img.style.transform = 'rotate(360deg)';
      // Optional: reset back after animation
      setTimeout(() => {
        img.style.transform = 'rotate(0deg)';
      }, 1000);
    }
    await fetchAnotherCollection(parenttt);
    document.querySelectorAll('.coll-main.active')
      .forEach(el => el.classList.remove('active'));
  }
});


// COLLECTION ITEM CLICK
document.addEventListener('click', async function (e) {
  const collItem = e.target.closest('.coll-main');
  if (!collItem) return;
  if (isCollectionLoading) return;
  const collectionContain = collItem.closest('.collectioncontain');
  if (!collectionContain) return;
  const parentCollection = collectionContain.getAttribute('parent-collection');
  const isActive = collItem.classList.contains('active');
  let handle;
  if (isActive) {
    handle = parentCollection;
    document.querySelectorAll('.coll-main')
      .forEach(el => el.classList.remove('active'));
  } else {
    handle = collItem.getAttribute('data-linkk');
    document.querySelectorAll('.coll-main')
      .forEach(el => el.classList.remove('active'));
    collItem.classList.add('active');
  }
  await fetchAnotherCollection(handle);
});
 

document.addEventListener('click',function(e){
const label=e.target.closest('body.collection details.mobile-facets__details[datafilters="Shape"] ul.facets-layout.facets-layout-list.facets-layout-list--text.mobile-facets__list li label,body.collection details.mobile-facets__details[datafilters="Metal"] ul.facets-layout.facets-layout-list.facets-layout-list--text.mobile-facets__list li label,body.collection details.mobile-facets__details.js-filter[datafilters="Total Carat Weight"] ul.facets-layout.facets-layout-list.facets-layout-list--text.mobile-facets__list li label,body.collection details.mobile-facets__details[datafilters="Category"] ul.facets-layout.facets-layout-list.facets-layout-list--text.mobile-facets__list li label');
if(!label)return;
const wrapper=label.closest('details.mobile-facets__details');
if(!wrapper)return;
wrapper.querySelectorAll('ul.facets-layout.facets-layout-list.facets-layout-list--text.mobile-facets__list li label').forEach(function(l){
if(l!==label){
const input=l.querySelector('input[type="checkbox"]');
if(input)input.checked=false;
l.classList.remove('active','is-active');
}
});
label.classList.add('active');
});




function firstselected(){
  $('.option-row[data-option-index="2"] .option-values,.option-row[data-option-index="3"] .option-values').each(function () {
  $(this).find('.option-btn').eq(0).addClass('active');
});
}



class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
      loaderact()
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
      loaderrmove();
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    var diamondcount = document.querySelector('span.total-items.count-all');
    var totalcount = document.querySelector('span.total-items.colll');
    if(diamondcount){
    diamondcount.innerHTML = `(${count})`;
    }
    if(totalcount){
    totalcount.innerHTML = `${count} Results`;
    }
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );


    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  setTimeout(() => {
    renderVariantOptions();
  }, 500);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    setTimeout(() => {
      renderVariantOptions();
      initInfiniteScroll();
    }, 500);
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);


$(document).on('click','body.collection .mobile-facets__inner ,body.collection .mobile-facets__footer.fdfdfdfdf button, body.collection menu-drawer summary.mobile-facets__open-wrapper .mobile-facets__open',function(){
  setTimeout(() => {
    initInfiniteScroll();
    renderVariantOptions();
  }, 500);
});
